module.exports = __webpack_public_path__ + "img/tutorial_classes_01.63b347be.gif";